<app-content-container [isLoading]="isProvidersStepLoading$ | async" [error]="providersStepError$ | async">
  <form [formGroup]="providerForm">
    <p-card data-cy="provider-list-container">
      <!-- Header -->
      <div class="flex align-items-center justify-content-between mb-4">
        <h3 class="my-0 required-label" data-cy="label">Select your provider for this order</h3>
        <button
          *ngIf="((providers$ | async)?.length || 0) > 0 && (providerUserData$ | async)?.newProviderFormValues === null"
          pButton
          type="button"
          label="Add new provider"
          icon="mi-round mi-add-circle-outline"
          class="p-button-text p-button-sm hidden md:flex"
          (click)="showModal()"
          data-cy="add-new-provider-button"
          appClickEvent
          eventName="order_wizard_add_provider"
        ></button>
      </div>
      <div
        *ngIf="
          providerForm.get('selectedProviderId')!.invalid &&
          providerForm.get('selectedProviderId')!.errors &&
          (providerForm.get('selectedProviderId')!.dirty || providerForm.get('selectedProviderId')!.touched)
        "
      >
        <app-message
          *ngIf="providerForm.get('selectedProviderId')!.hasError('required')"
          severity="error"
          data-cy="error-required-message"
        >
          Please choose a provider.
        </app-message>
      </div>
      <!-- Providers List -->
      <div
        *ngIf="(providers$ | async)?.length === 0"
        class="empty-provider-container border-grey-200 py-4 px-4 sm:px-7 border-1"
      >
        <button
          pButton
          type="button"
          label="Add your provider"
          icon="mi-round mi-add-circle-outline"
          class="p-button-text p-button-sm"
          (click)="showModal()"
          data-cy="add-new-provider-button"
          appClickEvent
          eventName="order_wizard_add_provider"
        ></button>
      </div>
      <div *ngFor="let provider of providers$ | async">
        <app-radio-button-card
          [control]="asFormControl(providerForm.get('selectedProviderId'))"
          name="selectedProviderId"
          [value]="provider.id"
          [ariaLabel]="'Dr. ' + provider.fullName"
          [isSelected]="!!(provider.id === providerForm.get('selectedProviderId')?.value)"
          [handleSelect]="changeSelectedProvider.bind(this, provider.id)"
        >
          <div class="flex w-full justify-content-between">
            <div class="flex flex-column">
              <p class="mt-0 mb-1 p3 font-semibold" data-cy="provider-name">
                {{ 'Dr. ' + provider.fullName | titlecase }}
              </p>
              <div
                class="provider-details"
                [ngClass]="provider.id === providerForm.get('selectedProviderId')?.value ? 'selected' : 'unselected'"
              >
                <p class="p3 mt-0 mb-1" data-cy="provider-phone">
                  {{ provider.phoneNumber | formatPhone }}
                </p>
                <p class="p3 my-0" data-cy="provider-address">
                  {{ provider.address | formatAddress: { singleLine: true } }}
                </p>
              </div>
            </div>
            <div *ngIf="provider.id === -1">
              <button
                pButton
                type="button"
                label="Edit"
                icon="mi-round mi-edit"
                class="p-button-text p-button-sm mr-1"
                (click)="showModal()"
                data-cy="edit-provider-button"
                appClickEvent
                eventName="order_wizard_edit_provider"
              ></button>
            </div>
          </div>
        </app-radio-button-card>
      </div>
      <div
        *ngIf="((providers$ | async)?.length || 0) > 0 && (providerUserData$ | async)?.newProviderFormValues === null"
        class="flex md:hidden justify-content-center mt-5 mb-0"
      >
        <button
          pButton
          type="button"
          label="Add new provider"
          icon="mi-round mi-add-circle-outline"
          class="p-button-text"
          (click)="showModal()"
          data-cy="add-new-provider-button"
          appClickEvent
          eventName="order_wizard_add_provider"
        ></button>
      </div>
    </p-card>

    <div
      *ngIf="providerForm.get('selectedProviderId')?.value && (providerVisitVerification$ | async)?.required"
      data-cy="provider-last-visit-container"
      class="mt-5"
    >
      <p-card>
        <h3 class="mt-0 mb-4">
          Please provide the date of your last provider visit
          <span
            *ngIf="
              (lastProviderVisitValidationState$ | async)?.isLoading ||
              (nextProviderVisitValidationState$ | async)?.isLoading
            "
            data-cy="form-field-loading-spinner"
            ><p-progressSpinner styleClass="ml-2"></p-progressSpinner
          ></span>
        </h3>

        <div class="-mb-4">
          <div formGroupName="providerVisitFormValues">
            <app-form-field
              [control]="asFormControl(providerForm.get('providerVisitFormValues')!.get('lastProviderVisit'))"
              name="lastProviderVisit"
              label="Date of last provider visit"
              placeholder="mm/dd/yyyy"
              type="calendar"
              [limitWidth]="true"
            ></app-form-field>

            <div *ngIf="(lastProviderVisitValidationState$ | async)?.data === false" class="flex flex-column">
              <app-form-field
                [control]="asFormControl(providerForm.get('providerVisitFormValues')!.get('hasUpcomingVisit'))"
                name="hasUpcomingVisit"
                label="Do you have an upcoming provider visit?"
                errorLabel="Upcoming visit answer"
                type="radio"
                [options]="[
                  { label: 'Yes', value: true },
                  { label: 'No', value: false }
                ]"
                [limitWidth]="true"
                [horizontalLayout]="true"
              ></app-form-field>
              <app-form-field
                *ngIf="providerForm.get('providerVisitFormValues')?.get('hasUpcomingVisit')?.value === true"
                [control]="asFormControl(providerForm.get('providerVisitFormValues')!.get('nextProviderVisit'))"
                name="nextProviderVisit"
                label="When is your upcoming provider visit?"
                errorLabel="Date of next provider visit"
                placeholder="mm/dd/yyyy"
                type="calendar"
                [limitWidth]="true"
              ></app-form-field>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <app-wizard-footer
      [submitForm]="onSubmit.bind(this)"
      [disableNav]="
        (lastProviderVisitValidationState$ | async)?.isLoading || (nextProviderVisitValidationState$ | async)?.isLoading
      "
      [nextLabel]="
        (lastProviderVisitValidationState$ | async)?.isLoading || (nextProviderVisitValidationState$ | async)?.isLoading
          ? 'Updating Order...'
          : 'Next'
      "
    ></app-wizard-footer>
  </form>

  <!-- New Provider Modal -->
  <app-form-modal
    title="Add New Provider"
    [(visible)]="displayModal"
    formId="newProviderForm"
    (cancelForm)="onCancelNewProviderForm()"
  >
    <form
      [formGroup]="newProviderForm"
      (ngSubmit)="onSubmitNewProviderForm()"
      id="newProviderForm"
      data-cy="new-provider-form"
    >
      <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
        <app-form-field
          class="col-12 sm:col-6 sm:py-0 sm:px-1"
          [control]="asFormControl(newProviderForm.get('providerFirstName'))"
          name="providerFirstName"
          label="Provider First Name"
          type="input"
        ></app-form-field>
        <app-form-field
          class="col-12 sm:col-6 sm:py-0 sm:px-1"
          [control]="asFormControl(newProviderForm.get('providerLastName'))"
          name="providerLastName"
          label="Provider Last Name"
          type="input"
        ></app-form-field>
      </div>

      <app-form-field
        [control]="asFormControl(newProviderForm.get('npi'))"
        name="npi"
        label="NPI"
        type="input"
      ></app-form-field>
      <app-form-field
        [control]="asFormControl(newProviderForm.get('phoneNumber'))"
        name="phoneNumber"
        label="Phone"
        type="input"
        inputMask="(999) 999-9999"
        placeholder="(999) 999-9999"
        inputMode="numeric"
      ></app-form-field>
      <app-form-field
        [control]="asFormControl(newProviderForm.get('addressLine1'))"
        name="addressLine1"
        label="Address 1"
        type="input"
      ></app-form-field>
      <app-form-field
        [control]="asFormControl(newProviderForm.get('addressLine2'))"
        name="addressLine2"
        label="Address 2"
        type="input"
      ></app-form-field>
      <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
        <app-form-field
          class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
          [control]="asFormControl(newProviderForm.get('addressCity'))"
          name="addressCity"
          label="City"
          type="input"
        ></app-form-field>
        <app-form-field
          class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
          [control]="asFormControl(newProviderForm.get('addressState'))"
          name="addressState"
          label="State"
          type="dropdown"
          [options]="usStates"
          placeholder="Select State"
        ></app-form-field>
        <app-form-field
          class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
          [control]="asFormControl(newProviderForm.get('addressZip'))"
          name="addressZip"
          label="Zip"
          type="input"
        ></app-form-field>
      </div>
    </form>
  </app-form-modal>
</app-content-container>
